import {createSvgIcon} from '../create-svg-icon';

export const ChurchIcon = createSvgIcon(
  [<path d="M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h9v-4c0-.55.45-1 1-1s1 .45 1 1v4h9v-8l-4-1.78zM20 20h-5v-2.04c0-1.69-1.35-3.06-3-3.06s-3 1.37-3 3.06V20H4v-4.79l4-1.81v-3.35L12 8l4 2.04v3.35l4 1.81V20z" key="0" />,<circle cx="12" cy="12" r="1.5" key="1" />,]
, 'ChurchOutlined');
